module.exports = __webpack_public_path__ + "img/tab_search_data.809e2909.png";